import React, { useRef } from 'react';
import { htmlDecode } from '../helpers/functions';
import { motion } from 'framer-motion';
import { useIsScreenSize } from '../helpers/hooks';
import { FormDisplay } from './FormDisplay';
import cx from 'classnames';
import styles from './InteriorBlocks.module.scss';

import 'slick-carousel/slick/slick.css';

export const InteriorBlocks = ({
  variant,
  title,
  subTitle,
  content,
  backgroundImage,
  primaryImage,
  wrapperClassBlock,
  button,
  form,
}) => {
  const ref = React.useRef();

  // Block Mapping Guide
  // 0 : Select Block
  // 1 : Image Right / Content Left
  // 2 : Image Left / Content Right
  // 3 : Timeline
  // 4 : Team Display
  // 5 : Featured Home Display
  // 6 : Form Display
  // 7 : Call Out

  const wrapperClass = {
    default: `bg-no-repeat px-4 lg:px-0`,
    1: `mb-12 sm:mb-0 sm:py-12`,
    2: `mb-12 sm:mb-0 sm:py-12`,
    3: `py-20`,
    4: `py-16 md:bg-center`,
    5: `py-20`,
    6: `p-4 bg-gray-light`,
    7: `py-20 bg-gray-light`,
  };

  const containerClass = {
    default: `container`,
    1: `flex flex-wrap md:flex-nowrap items-center`,
    2: `flex flex-wrap md:flex-nowrap items-center`,
    3: `flex flex-wrap sm:flex-nowrap items-center`,
    7: `flex justify-center`,
  };

  const primaryImageClass = {
    default: `lazyload relative`,
    1: `w-full md:w-4/12`,
    2: `w-full md:w-4/12 order-last md:order-first`,
    3: ``,
    6: `block mt-12`,
    img: {
      default: `relative z-10`,
      3: ``,
    },
  };

  const secondaryImageClass = {
    default: ``,
    img: {
      default: `relative z-10`,
    },
  };

  const contentWrapper = {
    default: ``,
    1: `w-full md:w-8/12 pr-0 md:pr-12 mb-8 md:mb-0`,
    2: `w-full md:w-8/12 pl-0 md:pl-12 mb-8 md:mb-0 order-2`,
    3: `w-full sm:w-1/2 pr-0 sm:pr-12 mb-8 sm:mb-0`,
    7: `p-4`,
  };

  const titleBoxClass = {
    default: `pl-4 border-l-8 border-primary leading-4 pt-2 ml-4 xl:ml-0 mb-8`,
  };

  const titleClass = {
    default: ``,
    6: ``,
  };

  const subTitleClass = {
    default: `mb-0 text-content font-normal leading-6`,
  };

  const contentClass = {
    default: `relative z-10`,
    6: `px-4 mb-8`,
  };

  const buttonClass = {
    default: `mt-6`,
  };

  console.log(primaryImage);
  return (
    <div
      className={cx(
        wrapperClass.default,
        wrapperClass[variant],
        styles[`block-${variant}`],
        wrapperClassBlock
      )}
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage.url})`
          : `none`,
      }}
    >
      {title || content || form ? (
        <div className={cx(containerClass.default, containerClass[variant])}>
          <div className={cx(contentWrapper.default, contentWrapper[variant])}>
            {title && !subTitle && (
              <h2
                className={cx(titleClass.default, titleClass[variant])}
                dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
              />
            )}
            {title && subTitle && (
              <div
                className={cx(titleBoxClass.default, titleBoxClass[variant])}
              >
                <h2
                  className={cx(titleClass.default, titleClass[variant])}
                  dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
                />
                <h4
                  className={cx(subTitleClass.default, subTitleClass[variant])}
                  dangerouslySetInnerHTML={{ __html: htmlDecode(subTitle) }}
                />
              </div>
            )}
            {content && (
              <div
                className={cx(contentClass.default, contentClass[variant])}
                dangerouslySetInnerHTML={{ __html: htmlDecode(content) }}
              />
            )}
            {form && <FormDisplay fields={form} />}
            {button && (
              <div className={cx(buttonClass.default, buttonClass[variant])}>
                <a
                  href={button.url}
                  className="btn"
                  dangerouslySetInnerHTML={{ __html: htmlDecode(button.label) }}
                />
              </div>
            )}
          </div>
          {primaryImage && (
            <motion.picture
              className={cx(
                primaryImageClass.default,
                primaryImageClass[variant]
              )}
            >
              <img
                src={primaryImage.url}
                alt={primaryImage.alt}
                className={cx(
                  primaryImageClass.img.default,
                  primaryImageClass.img[variant]
                )}
              />
            </motion.picture>
          )}
        </div>
      ) : null}
    </div>
  );
};
